<template>

    <div class="main-top-margin">

      <v-tabs
        @change="changeTab"
        v-model="activeTab"
        background-color="transparent"
        color="#26262A"
        slider-color="#26262A"
        class="tabs-primary"
        :hide-slider="false"
        slider-size="2"
      >
        <v-tab><lang t="DERIVATION_RULES-TAB-RULES"></lang></v-tab>
        <v-tab><lang t="DERIVATION_RULES-TAB-CONSTANTS"></lang></v-tab>
      </v-tabs>


        <v-tabs-items v-model="activeTab"  class=" mt-2">

          <v-tab-item class="py-6 pt-12">
            <tab-rules></tab-rules>
          </v-tab-item>

          <v-tab-item class="py-6 pt-12">
            <tab-constants></tab-constants>

          </v-tab-item>

        </v-tabs-items>



    </div>

</template>

<script>
import tabRules from './Tab-Rules.vue';
import tabConstants from './Tab-Constants.vue';

export default {
  name: 'CalculationsIndex',

  components: {
    tabRules,
    tabConstants,
  },

  data: () => ({
      isSaving: false,
      isLoading: true,
      activeTab: 0,
  }),

  watch: {

    "dialog.show"(val) {
        val || this.closeModal()
    }

  },

  computed: {


  },

  created() {

  },

  mounted() {

  },

  methods: {


  }
}

</script>



<style lang="scss" scoped>

.v-tabs-items{
  background-color: transparent;
}

</style>
